/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Banner_Capabilities_Bind_All_DescriptionInputs */



/**
* | output |
* | --- |
* | "A denial reaches every member of the organization, administrators included — an organization default of \"deny\" denies you as well. You can always lift your o..." |
*
* @param {Rights_Banner_Capabilities_Bind_All_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_banner_capabilities_bind_all_description = /** @type {((inputs?: Rights_Banner_Capabilities_Bind_All_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Banner_Capabilities_Bind_All_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Entzug gilt für alle Mitglieder der Organisation, Administratoren eingeschlossen — eine Organisationsvorgabe „Verweigern“ verweigert auch Ihnen. Ihren eigenen Entzug können Sie jederzeit hier aufheben: Diese Seite wird über die Administratorrolle gesteuert, nie über eine Berechtigung.")
	return /** @type {LocalizedString} */ ("A denial reaches every member of the organization, administrators included — an organization default of \"deny\" denies you as well. You can always lift your own denial here: this page is governed by the administrator role, never by a capability.")
});